export default __webpack_public_path__ + "static/media/gameplay-middle-new.645b6211.png";